import ChessBoard from '../components/ChessBoard';

export default function OpeningTrainer() {
  return (
    <div className='opening-trainer-container'>
      <ChessBoard />
      <div className='opening-trainer-text-container'>
        <h2 style={{marginBottom: '1rem'}}>Help</h2>
        <p style={{marginTop: '0', maxWidth: '800px'}}>
          This is an opening trainer designed to simulate a game vs the Lichess Openings Database. When the Play button is activated, your opponent will make moves by randomly selecting moves from the database you have selected/customized.
          This effectively simulates a game played against a random player from the pool represented by the openings database. You can choose a starting position and Save it for easy resetting. At any point you may also choose to Analyze the game on Lichess to see where you went wrong.
        </p>
      </div>
    </div>
  )
}
  